import { useTranslation } from "react-i18next";

import { ProfileCompanyLoadingStyled } from "./profile.modal.styled";

export const ProfileModalLoading = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ProfileCompanyLoadingStyled>
      {t("general.LOADING_COMPANY_LIST")}
    </ProfileCompanyLoadingStyled>
  );
};
